import {Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {ToastService} from "../../services/Toast.service";
import {StateService} from "../../services/StateService";
import {SwitchBoard} from "../../services/SwitchBoard";
import {ActivatedRoute, Router} from "@angular/router";
import {LoginService} from "../../services/Login.service";
import {LogoService} from "../../services/LogoService";
import {LoadingService} from "../../services/LoadingService";
import {QuestionnairesSurveysService} from "../../services/questionnaires-surveys.service";
import {PageTitleService} from "../../services/PageTitle";
import {takeUntil} from "rxjs/operators";
import {CacheService} from "../../services/cache.service";
import {Session} from "../../services/Session";
import { RouterModule } from '@angular/router';
import { ViewEncapsulation } from '@angular/core';

declare let jQuery: any;
declare let _: any;
declare let window: any;

@Component({
  selector: 'app-customer-sidebar',
  standalone: true,
  imports: [CommonModule, FormsModule,RouterModule],
  templateUrl: './customer-sidebar.component.html',
  styleUrls: ['./customer-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomerSidebarComponent implements  OnInit, OnDestroy {
  isTODO: boolean;
  selectedChannelId: string;
  @Input() isExpanded: boolean;
  user: any;
  @ViewChild('tpiq') title: ElementRef;
  routeSub: any;
  loginUser: String;
  theme = 'wallTheme';
  isWindowFocused = true;
  currentView = 'wall';
  pages = {wall: false, hop: false, toDo: false,  home: false, taxPlanningStatus: false, questionnaire: false, taxEstimates: false};
  org: string;
  pagesThemes = {wall: 'wallTheme', toDo: 'tasksTheme', home: 'wallTheme',
    taxPlanningStatus: 'tasksTheme'};
  logoBg: any;
  orgName: string;
  logoSub: any;
  todoCount: number;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  delegatedUser: any;
  channels: any;
  clientsView: boolean;
  channelType = '';
  channelId = '';

  constructor(private switchBoard: SwitchBoard, private _router: Router, private stateService: StateService,
              private titleService: PageTitleService, private _route: ActivatedRoute,
              private loadingService: LoadingService, private cacheService: CacheService,
              private loginService: LoginService, private toastService: ToastService,
              private logoService: LogoService, private qsService: QuestionnairesSurveysService) {
  }

  ngOnInit(){
    this._init();
    this.switchBoard.onLogOut.pipe(takeUntil(this.destroy$)).subscribe(status => {
      this.cacheService.removeCache();
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  _init() {
    const base = this;
    this.org = Session.getOrg();
    this.delegatedUser = Session.get('delegatedFrom');
    this.clientsView = false;
    this.handleSidemenuImage();
    this.logoSub = this.switchBoard.onLogosReady.pipe(takeUntil(this.destroy$)).subscribe(response => {
      this.handleSidemenuImage();
    });
    this.loginUser = Session.getUser().id;
    this.user = Session.getUser();
    this.titleService.setPageTitle(Session.getCurrentCompanyName());

    this.switchBoard.onWallSideBarChange.pipe(takeUntil(this.destroy$)).subscribe(obj => {
      this.switchBoard.onSidebarChange.next(obj);
    });

    this.switchBoard.onSidebarChange.subscribe(obj => {
      this.changeView(obj.view);
    });

    this.qsService.getQuestionnaireDetails(this.org, this.user.id).subscribe(response => {

    }, error => {});
  }

  handleSidemenuImage(){
    const base = this;
    this.orgName = this.logoService.getOrg();
    const sideMenuLogo = this.logoService.getSidebarLogoUrl();
    if (sideMenuLogo){
      this.logoBg = {
        background: 'url("' + sideMenuLogo + '") center center no-repeat',
        'background-size': 'contain'
      };
    }
  }

  initWindowFocus(){
    const base = this;
    jQuery(window).blur(function(){
      base.isWindowFocused = false;
    });
    jQuery(window).focus(function(){
      base.isWindowFocused = true;
    });
  }

  logout() {
    this.switchBoard.onLogOut.next({loggedOut: true});
  }

  showPage(page, pageFrom?) {
    const base = this;
    this.stateService.clearAllStates();
    this.resetAllTabs(page);
    if (page === 'tax-planning/customer/dashboard') {
      Session.setConversation(null);
      const link = [page];
      this._router.navigate(link);
      this.clearMenuFilter();
    } else if (page === 'toDo') {
      const link = [page, 'all'];
      this._router.navigate(link);
      this.clearMenuFilter();
    } else if (page === 'tax-planning/tax-estimates') {
      this.pages['taxEstimates'] = true;
      const link = ['tax-planning/tax-estimates'];
      this._router.navigate(link);
    }  else if (page !== 'hop') {
      const link = [page];
      this._router.navigate(link);
    }
  }

  resetAllTabs(page) {
    const base = this;
    if (this.pagesThemes[page]) {
      this.changeTheme(this.pagesThemes[page]);
    }
    _.each(this.pages, function(val, key) {
      if (key == page){
        base.pages[key] = true;
      }else{
        base.pages[key] = false;
      }
    });
  }

  toggleMenu(type){
    this.isExpanded = type;
    this.switchBoard.onSideBarExpand.next(this.isExpanded);
  }

  showError(err){

  }
  changeTheme(type) {
    this.theme = type;
    this.switchBoard.onThemeChange.next(type);
  }

  changeView(routeName) {
    this.selectedChannelId = '';
    this.currentView = routeName;
    const page = routeName;
    this.showPage(page);
  }

  clearMenuFilter(){
    this.switchBoard.onClearMenuFilter.next({});
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    const base = this;
    if (this.title?.nativeElement?.classList?.contains('is-open')) {
      jQuery('#side-export-dropdown-id').foundation('toggle');
    }
  }

  togglePreferences($event){
    $event && $event.preventDefault();
    $event && $event.stopImmediatePropagation();
    jQuery('#side-export-dropdown-id').foundation('toggle');
  }

  getUserBadgeName(user) {
    if (user) {
      const firstletter = user.first_name ? user.first_name.charAt(0) : '';
      const lastletter = user.last_name ? user.last_name.charAt(0) : '';
      return firstletter + lastletter;
    }
    return '';
  }

}
